import { Table } from "react-bootstrap";
import SpinnerBlock from "components/others/SpinnerBlock";
import TableHeadTdOrder from "components/others/TableHeadTdOrder";
import { useTranslation } from "react-i18next";
import { useWarehouse } from "./context/WarehouseProvider";
import WarehouseTableBody from "./WarehouseTableBody";
import { useAuth } from "context/AuthContext";
import { useSettings } from "context/SettingsContext";
import vconst from "utils/helpers/structs/vconst";
import { hidesPurchasePrices } from "utils/helpers/access/hasUserAccess";

const WarehouseTable = ({wId, stocksList, setShowTransfer, setShowComing, setShowPaymentsId, setShowPaymentsTitle, setShowStockLots, stockLots = null, fetchStocks, onlyView = false}: any) => {

    const { t } = useTranslation(['Warehouses']);
    const { auth } = useAuth();
    const { localSettings } = useSettings();
    const { showSpinner,
            stocksOrder, setStocksOrder,
            stocksDesc, setStocksDesc,
            showCredit,
            showCategory,
            showArticle,
            showUpdated,
            showLotBreakdown } = useWarehouse();
    const isUahMode = (Number(localSettings?.RATE?.current ?? 1) || 1) === 1;
    const lotsPending = Boolean(showLotBreakdown && stockLots == null);

    const showBalanceColumn =
        showCredit &&
        auth?.user?.access?.role === 'manager' &&
        !hidesPurchasePrices(auth?.user) &&
        wId === vconst.waherouseMainId;
    const tableMinWidth = 520
        + (showCategory ? 160 : 0)
        + (showArticle ? 150 : 0)
        + (showUpdated ? 130 : 0)
        + (showBalanceColumn ? 120 : 0)
        + (showLotBreakdown ? (isUahMode ? 140 : 220) : 0);

    const handleOrderClick = (value: string, desc: boolean) => {
        setStocksOrder(value); 
        setStocksDesc(desc);
    }

    return (<>
        <SpinnerBlock 
            onlyBlur={true}
            show={showSpinner || lotsPending}/> 

        <div className="crm-table-wrap">
            <Table
                className={`StockTable table-hover${showLotBreakdown ? ` StockTable--lots${isUahMode ? ' StockTable--lots-uah' : ''}` : ''}`}
                style={{ minWidth: tableMinWidth }}
            >
                <thead>
                    <tr className="bg-light">
                        <td className="head-name">
                            <TableHeadTdOrder
                                title={t('fields.prodName')}
                                onClick={handleOrderClick}
                                value={stocksOrder}
                                desc={stocksDesc}
                                fieldName='prod_name'/>

                            </td>
                        {showCategory ? (
                        <td className="head-category">
                            <TableHeadTdOrder
                                title={t('fields.category')}
                                onClick={handleOrderClick}
                                value={stocksOrder}
                                desc={stocksDesc}
                                fieldName='category_name'/>
                        </td>
                        ) : null}
                        {showArticle ? (
                        <td className="head-article">
                            <TableHeadTdOrder
                                title={t('fields.article')}
                                onClick={handleOrderClick}
                                value={stocksOrder}
                                desc={stocksDesc}
                                fieldName='prod_article'/>    
                        </td>
                        ) : null}
                        {showBalanceColumn && (
                            <td className="head-balance">
                                <TableHeadTdOrder
                                    title={t('fields.balance')}
                                    onClick={handleOrderClick}
                                    value={stocksOrder}
                                    desc={stocksDesc}
                                    className="cursor-pointer d-flex align-items-center justify-content-end"
                                    fieldName='stock_balance'/>
                            </td>
                        )}
                        {showUpdated ? (
                        <td className="head-updated">
                            <TableHeadTdOrder
                                title={t('fields.updated')}
                                onClick={handleOrderClick}
                                value={stocksOrder}
                                desc={stocksDesc}
                                fieldName='stock_updated'/>    
                        </td>
                        ) : null}
                        <td className="head-count">
                            <div className="d-flex align-items-center justify-content-center flex-wrap column-gap-1">
                                <TableHeadTdOrder
                                    title={t('fields.countEnd')}
                                    onClick={handleOrderClick}
                                    value={stocksOrder}
                                    desc={stocksDesc}
                                    className="cursor-pointer d-flex align-items-center justify-content-center"
                                    fieldName='stock_count'/>
                                {showLotBreakdown && (
                                    <span className="text-muted fw-normal">
                                        {isUahMode ? t('lotsHeadHintUah') : t('lotsHeadHint')}
                                    </span>
                                )}
                            </div>
                        </td>

                        {!onlyView && 
                        (<td className="head-action">
                            {t('fields.action')}
                        </td>)}
     
                    </tr>
                </thead> 

                <WarehouseTableBody
                    wId={wId}
                    onlyView={onlyView}
                    showBalanceColumn={showBalanceColumn}
                    setShowPaymentsId={setShowPaymentsId}
                    setShowPaymentsTitle={setShowPaymentsTitle}
                    setShowTransfer={setShowTransfer}
                    setShowComing={setShowComing}
                    setShowStockLots={setShowStockLots}
                    stockLots={stockLots}
                    fetchStocks={fetchStocks}
                    stocksList={stocksList}/>

            </Table>
        </div>
        </>)
}

export default WarehouseTable;